import React from "react";

function AboutInfo() {
  return (
    <div>
      <h1>Clarusway Online IT Bootcamp</h1>
      <h4>Reinvent Yourself</h4>
    </div>
  );
}

export default AboutInfo;
